import * as i0 from '@angular/core';
import { inject, Injector, ChangeDetectorRef, ViewContainerRef, Component, ChangeDetectionStrategy, Input, ViewChild, HostBinding, EventEmitter, isDevMode, Output, Directive } from '@angular/core';
import { extractFunctionDefaults } from '@ng-doc/core/helpers/extract-function-defaults';
import { Subject, take } from 'rxjs';
import { AsyncPipe, NgIf, NgFor, KeyValuePipe } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1$1 from '@ng-doc/app/classes/root-page';
import { isSameObject } from '@ng-doc/core/helpers/is-same-object';
import { objectKeys } from '@ng-doc/core/helpers/object-keys';
import { NgDocSmoothResizeComponent, NgDocLetDirective, NgDocLabelComponent, NgDocTooltipDirective, NgDocTextComponent, NgDocButtonComponent, NgDocCheckboxComponent, NgDocIconComponent, NgDocTextRightDirective, NgDocBindPipe, NgDocExecutePipe, NgDocAsArrayPipe } from '@ng-doc/ui-kit';
import { __decorate } from 'tslib';
import { NgDocDemoDisplayerComponent } from '@ng-doc/app/components/demo-displayer';
import { formatHtml, isPlaygroundProperty } from '@ng-doc/app/helpers';
import { getPlaygroundDemoToken } from '@ng-doc/app/providers/playground-demo';
import { buildPlaygroundDemoPipeTemplate, buildPlaygroundDemoTemplate } from '@ng-doc/core/helpers/build-playground-demo-template';
import { stringify } from '@ng-doc/core/helpers/stringify';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { takeUntil, startWith, map } from 'rxjs/operators';
import * as i1 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import { getTokenForType } from '@ng-doc/app/providers/type-control';
import { extractValueOrThrow } from '@ng-doc/core/helpers/extract-value';
import { isPresent } from '@ng-doc/core/helpers/is-present';
import { NgDocSanitizeHtmlPipe } from '@ng-doc/app/pipes';
const _c0 = ["demoOutlet"];
const _c1 = ["propertyOutlet"];
const _c2 = () => ["left-center", "top-right", "bottom-right"];
function NgDocPlaygroundPropertyComponent_ng_template_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "ngDocSanitizeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.tooltipContent), i0.ɵɵsanitizeHtml);
  }
}
function NgDocPlaygroundPropertyComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, NgDocPlaygroundPropertyComponent_ng_template_1_ng_template_2_Template, 2, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const tooltipTemplate_r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngDocTooltip", tooltipTemplate_r2)("canOpen", !!ctx_r0.tooltipContent)("positions", i0.ɵɵpureFunction0(4, _c2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.name);
  }
}
const _c3 = ["*"];
const _c4 = () => ["bottom-right", "left-center"];
function NgDocPlaygroundPropertiesComponent_div_0_div_4_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function NgDocPlaygroundPropertiesComponent_div_0_div_4_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.resetForm.emit());
    });
    i0.ɵɵtext(1, " Reset ");
    i0.ɵɵelementEnd();
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_11_ng_doc_playground_property_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-playground-property", 17);
    i0.ɵɵpipe(1, "bind");
    i0.ɵɵpipe(2, "execute");
  }
  if (rf & 2) {
    const propertyControl_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("name", propertyControl_r4.property.inputName)("property", propertyControl_r4.property)("typeControl", propertyControl_r4.typeControl)("defaultValue", ctx_r2.defaultValues[propertyControl_r4.propertyName])("control", i0.ɵɵpipeBind3(2, 8, i0.ɵɵpipeBind2(1, 5, ctx_r2.getFormControl, ctx_r2), "properties", propertyControl_r4.propertyName));
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h5", 15);
    i0.ɵɵtext(2, "Settings");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_11_ng_doc_playground_property_3_Template, 3, 12, "ng-doc-playground-property", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.propertyControls);
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_12_ng_doc_playground_property_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-playground-property", 19);
    i0.ɵɵpipe(1, "bind");
    i0.ɵɵpipe(2, "execute");
  }
  if (rf & 2) {
    const content_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("name", content_r5.value.label)("property", content_r5.value)("typeControl", ctx_r2.contentTypeControl)("control", i0.ɵɵpipeBind3(2, 7, i0.ɵɵpipeBind2(1, 4, ctx_r2.getFormControl, ctx_r2), "content", content_r5.key));
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h5", 15);
    i0.ɵɵtext(2, "Content");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_12_ng_doc_playground_property_3_Template, 3, 11, "ng-doc-playground-property", 18);
    i0.ɵɵpipe(4, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 1, ctx_r2.dynamicContent));
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "h4", 6);
    i0.ɵɵtext(3, "Playground");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NgDocPlaygroundPropertiesComponent_div_0_div_4_button_4_Template, 2, 0, "button", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8)(6, "ng-doc-checkbox", 9);
    i0.ɵɵtwoWayListener("ngModelChange", function NgDocPlaygroundPropertiesComponent_div_0_div_4_Template_ng_doc_checkbox_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.recreateDemo, $event) || (ctx_r2.recreateDemo = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function NgDocPlaygroundPropertiesComponent_div_0_div_4_Template_ng_doc_checkbox_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.recreateDemoChange.emit($event));
    });
    i0.ɵɵelementStart(7, "span", 10);
    i0.ɵɵtext(8, " Recreate ");
    i0.ɵɵelement(9, "ng-doc-icon", 11);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(10, "div", 12);
    i0.ɵɵtemplate(11, NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_11_Template, 4, 1, "ng-container", 13)(12, NgDocPlaygroundPropertiesComponent_div_0_div_4_ng_container_12_Template, 5, 3, "ng-container", 13);
    i0.ɵɵpipe(13, "keyvalue");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.showResetButton);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.recreateDemo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngDocTooltip", "Recreates demo everytime\none of the input has changed")("positions", i0.ɵɵpureFunction0(8, _c4));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.propertyControls.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_7_0 = i0.ɵɵpipeBind1(13, 6, ctx_r2.dynamicContent)) == null ? null : tmp_7_0.length);
  }
}
function NgDocPlaygroundPropertiesComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NgDocPlaygroundPropertiesComponent_div_0_div_4_Template, 14, 9, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("vertical", i0.ɵɵpipeBind1(1, 3, ctx_r2.observer));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideSidePanel);
  }
}
function NgDocPlaygroundComponent_ng_container_0_ng_doc_playground_demo_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-playground-demo", 4);
  }
  if (rf & 2) {
    let tmp_9_0;
    const selector_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r1.id)("selector", selector_r3)("properties", ctx_r1.properties)("configuration", ctx_r1.configuration)("recreateDemo", ctx_r1.recreateDemo)("form", ctx_r1.formGroup)("expanded", (tmp_9_0 = ctx_r1.configuration.expanded) !== null && tmp_9_0 !== undefined ? tmp_9_0 : false);
  }
}
function NgDocPlaygroundComponent_ng_container_0_ng_doc_playground_demo_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-playground-demo", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r1.id)("pipeName", ctx_r1.pipeName)("properties", ctx_r1.properties)("configuration", ctx_r1.configuration)("recreateDemo", ctx_r1.recreateDemo)("form", ctx_r1.formGroup);
  }
}
function NgDocPlaygroundComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ng-doc-playground-properties", 1);
    i0.ɵɵtwoWayListener("recreateDemoChange", function NgDocPlaygroundComponent_ng_container_0_Template_ng_doc_playground_properties_recreateDemoChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.recreateDemo, $event) || (ctx_r1.recreateDemo = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("resetForm", function NgDocPlaygroundComponent_ng_container_0_Template_ng_doc_playground_properties_resetForm_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resetForm());
    });
    i0.ɵɵtemplate(2, NgDocPlaygroundComponent_ng_container_0_ng_doc_playground_demo_2_Template, 1, 7, "ng-doc-playground-demo", 2);
    i0.ɵɵpipe(3, "asArray");
    i0.ɵɵtemplate(4, NgDocPlaygroundComponent_ng_container_0_ng_doc_playground_demo_4_Template, 1, 6, "ng-doc-playground-demo", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.formGroup)("properties", ctx_r1.properties)("ignoreInputs", ctx_r1.configuration.hiddenInputs)("dynamicContent", ctx_r1.configuration.content)("hideSidePanel", (tmp_5_0 = ctx_r1.configuration.hideSidePanel) !== null && tmp_5_0 !== undefined ? tmp_5_0 : false)("defaultValues", ctx_r1.defaultValues)("showResetButton", !ctx_r1.isDefaultState());
    i0.ɵɵtwoWayProperty("recreateDemo", ctx_r1.recreateDemo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 10, (tmp_9_0 = ctx_r1.configuration.selectors) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ctx_r1.selectors));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.pipeName);
  }
}
let NgDocPlaygroundDemoComponent = /*#__PURE__*/(() => {
  let NgDocPlaygroundDemoComponent = class NgDocPlaygroundDemoComponent {
    constructor() {
      this.id = '';
      this.pipeName = '';
      this.selector = '';
      this.recreateDemo = false;
      this.expanded = false;
      this.code = '';
      this.injector = inject(Injector);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.unsubscribe$ = new Subject();
    }
    async ngOnChanges({
      form,
      id
    }) {
      if (form || id) {
        this.unsubscribe$.next();
        const demoInjector = getPlaygroundDemoToken(this.id);
        if (demoInjector) {
          const demos = this.injector.get(demoInjector, []);
          this.playgroundDemo = demos.find(demo => demo.selector === this.selector || demo.selector === this.pipeName);
        }
        await this.updateDemo();
        this.form?.valueChanges.pipe(takeUntil(this.unsubscribe$), untilDestroyed(this), startWith(this.form?.value)).subscribe(data => this.updateDemo(data));
      }
    }
    async updateDemo(data) {
      if (this.recreateDemo || !this.demoRef) {
        this.createDemo();
      }
      if (data) {
        this.demoRef?.setInput('properties', data.properties ?? {});
        this.demoRef?.setInput('content', data.content ?? {});
        this.demoRef?.setInput('actionData', this.configuration?.data ?? {});
        if (this.recreateDemo) {
          this.demoRef?.instance.onReattached.subscribe(() => {
            this.demoRef?.changeDetectorRef.detectChanges();
          });
        }
      }
      await this.updateCodeView();
    }
    createDemo() {
      if (this.playgroundDemo) {
        this.demoRef?.destroy();
        this.demoRef = this.demoOutlet?.createComponent(this.playgroundDemo);
        this.demoRef?.changeDetectorRef.markForCheck();
      }
    }
    async updateCodeView() {
      const template = this.pipeName ? buildPlaygroundDemoPipeTemplate(this.configuration?.template ?? '', this.pipeName, this.getActiveContent(), this.getPipeActiveInputs()) : buildPlaygroundDemoTemplate(this.configuration?.template ?? '', this.selector, this.getActiveContent(), this.getActiveInputs());
      this.code = await formatHtml(template);
      this.changeDetectorRef.markForCheck();
    }
    getActiveContent() {
      const formData = this.form?.controls.content.value ?? {};
      return objectKeys(formData).reduce((result, key) => {
        result[key] = formData[key] ? this.configuration?.content?.[key].template ?? '' : '';
        return result;
      }, {});
    }
    getActiveInputs() {
      const formData = this.form?.controls.properties.value ?? {};
      return objectKeys(formData).reduce((result, key) => {
        const inputName = this.properties?.[key]?.inputName ?? key;
        const value = formData[key];
        const property = this.demoRef?.instance?.defaultValues[key];
        if (property !== value) {
          result[inputName] = stringify(value).replace(/"/g, `'`);
        }
        return result;
      }, {});
    }
    getPipeActiveInputs() {
      const formData = this.form?.controls.properties.value ?? {};
      let changedInputIndex = -1;
      return objectKeys(formData).map((key, i) => {
        const value = formData[key];
        const defaultValue = this.demoRef?.instance?.defaultValues[key];
        if (defaultValue !== value) {
          changedInputIndex = i;
        }
        return key;
      }).slice(0, changedInputIndex + 1).reduce((result, key) => {
        result[key] = stringify(formData[key]).replace(/"/g, `'`);
        return result;
      }, {});
    }
    ngOnDestroy() {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
    static {
      this.ɵfac = function NgDocPlaygroundDemoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPlaygroundDemoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPlaygroundDemoComponent,
        selectors: [["ng-doc-playground-demo"]],
        viewQuery: function NgDocPlaygroundDemoComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.demoOutlet = _t.first);
          }
        },
        inputs: {
          id: "id",
          pipeName: "pipeName",
          selector: "selector",
          configuration: "configuration",
          properties: "properties",
          recreateDemo: "recreateDemo",
          form: "form",
          expanded: "expanded"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 4,
        consts: [["demoOutlet", ""], [3, "trigger"], ["language", "angular-html", 3, "code", "border", "expanded"]],
        template: function NgDocPlaygroundDemoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ng-doc-smooth-resize", 1)(1, "ng-doc-demo-displayer", 2);
            i0.ɵɵelementContainer(2, null, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("trigger", ctx.code);
            i0.ɵɵadvance();
            i0.ɵɵproperty("code", ctx.code)("border", false)("expanded", ctx.expanded);
          }
        },
        dependencies: [NgDocDemoDisplayerComponent, NgDocSmoothResizeComponent],
        styles: ["[_nghost-%COMP%]{display:block;border:var(--ng-doc-demo-displayer-border);border-radius:var(--ng-doc-demo-displayer-border-radius);overflow:hidden}[_nghost-%COMP%]:not(:last-child){border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}[_nghost-%COMP%]:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}"],
        changeDetection: 0
      });
    }
  };
  NgDocPlaygroundDemoComponent = __decorate([UntilDestroy()], NgDocPlaygroundDemoComponent);
  return NgDocPlaygroundDemoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocPlaygroundPropertyComponent = /*#__PURE__*/(() => {
  class NgDocPlaygroundPropertyComponent {
    constructor() {
      this.name = '';
    }
    ngOnChanges({
      property,
      control,
      typeControl,
      defaultValue
    }) {
      if ((property || control || typeControl || defaultValue) && this.property && this.typeControl) {
        this.propertyTypeControl?.destroy();
        this.propertyTypeControl = undefined;
        if (this.typeControl && this.propertyOutlet) {
          this.propertyTypeControl = this.propertyOutlet.createComponent(this.typeControl.control);
          this.propertyTypeControl.instance.name = this.name;
          this.propertyTypeControl.instance.description = this.tooltipContent;
          this.propertyTypeControl.instance.options = isPlaygroundProperty(this.property) ? this.property.options : undefined;
          this.propertyTypeControl.instance.default = this.defaultValue;
          this.propertyTypeControl.instance.isManual = isPlaygroundProperty(this.property) ? this.property.isManual : undefined;
          this.propertyTypeControl.instance.writeValue(this.control?.value);
          this.option = this.typeControl.options;
        }
        if (this.control) {
          this.control?.registerOnChange(value => this.propertyTypeControl?.instance?.writeValue(value));
          this.propertyTypeControl?.instance.registerOnChange(value => this.control?.setValue(value));
          this.propertyTypeControl?.instance.registerOnTouched(() => this.control?.markAsTouched());
        }
      }
    }
    get hasPropertyControl() {
      return !!this.propertyTypeControl;
    }
    get tooltipContent() {
      return this.property && isPlaygroundProperty(this.property) ? this.property.description ?? '' : '';
    }
    static {
      this.ɵfac = function NgDocPlaygroundPropertyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPlaygroundPropertyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPlaygroundPropertyComponent,
        selectors: [["ng-doc-playground-property"]],
        viewQuery: function NgDocPlaygroundPropertyComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.propertyOutlet = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function NgDocPlaygroundPropertyComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-has-property-control", ctx.hasPropertyControl);
          }
        },
        inputs: {
          name: "name",
          property: "property",
          typeControl: "typeControl",
          control: "control",
          defaultValue: "defaultValue"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 1,
        consts: [["labelContent", ""], ["propertyOutlet", ""], ["tooltipTemplate", ""], [3, "ng-doc-label"], [3, "ngDocTooltip", "canOpen", "positions"], [3, "innerHTML"]],
        template: function NgDocPlaygroundPropertyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 3);
            i0.ɵɵtemplate(1, NgDocPlaygroundPropertyComponent_ng_template_1_Template, 4, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementContainer(3, null, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const labelContent_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ng-doc-label", (ctx.option == null ? null : ctx.option.hideLabel) ? "" : labelContent_r3);
          }
        },
        dependencies: [NgDocLabelComponent, NgDocTooltipDirective, NgDocSanitizeHtmlPipe],
        styles: ["[_nghost-%COMP%]{display:block}[data-has-property-control=false][_nghost-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return NgDocPlaygroundPropertyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocPlaygroundPropertiesComponent = /*#__PURE__*/(() => {
  class NgDocPlaygroundPropertiesComponent {
    constructor(breakpointObserver, injector) {
      this.breakpointObserver = breakpointObserver;
      this.injector = injector;
      this.ignoreInputs = [];
      this.hideSidePanel = false;
      this.recreateDemo = false;
      this.showResetButton = false;
      this.recreateDemoChange = new EventEmitter();
      this.resetForm = new EventEmitter();
      this.breakpoints = [Breakpoints.XSmall];
      this.propertyControls = [];
      this.contentTypeControl = this.getControlForType('boolean');
      this.observer = this.breakpointObserver.observe(this.breakpoints).pipe(map(state => state.matches));
    }
    ngOnChanges({
      properties
    }) {
      if (properties && this.properties) {
        this.propertyControls = objectKeys(this.properties).filter(key => this.ignoreInputs?.includes(String(key)) !== true).map(key => {
          if (this.properties) {
            const property = this.properties[key];
            const typeControl = this.getTypeControl(property);
            if (typeControl) {
              return {
                propertyName: String(key),
                property,
                typeControl
              };
            }
          }
          return null;
        }).filter(isPresent).sort((a, b) => {
          const aOrder = a.typeControl.options?.order;
          const bOrder = b.typeControl.options?.order;
          if (isPresent(aOrder) && isPresent(bOrder)) {
            return aOrder - bOrder;
          }
          if (isPresent(aOrder)) {
            return -1;
          }
          if (isPresent(bOrder)) {
            return 1;
          }
          return a.property.inputName.localeCompare(b.property.inputName);
        });
      }
    }
    getFormControl(controlType, key) {
      return this.form.get(controlType)?.get(key);
    }
    getTypeControl(property) {
      const type = property.type;
      const typeControl = this.getControlForType(type) ?? this.getControlForTypeAlias(isPlaygroundProperty(property) ? property.options : undefined, property.isManual);
      if (!typeControl && isDevMode()) {
        console.warn(`NgDocPlayground didn't find the control for the @Input "${property.inputName}", the type "${type}" was not recognized'`);
      }
      return typeControl;
    }
    getControlForType(type) {
      const token = getTokenForType(type);
      return token ? this.injector.get(token) : undefined;
    }
    getControlForTypeAlias(options, isManual) {
      if (options && options.length) {
        let optionsIsValid = true;
        if (!isManual) {
          try {
            // checking that all values are extractable
            options.forEach(item => extractValueOrThrow(item));
          } catch {
            optionsIsValid = false;
          }
        }
        if (optionsIsValid) {
          const token = getTokenForType('NgDocTypeAlias');
          return token ? this.injector.get(token) : undefined;
        }
      }
      return undefined;
    }
    static {
      this.ɵfac = function NgDocPlaygroundPropertiesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPlaygroundPropertiesComponent)(i0.ɵɵdirectiveInject(i1.BreakpointObserver), i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPlaygroundPropertiesComponent,
        selectors: [["ng-doc-playground-properties"]],
        inputs: {
          form: "form",
          properties: "properties",
          ignoreInputs: "ignoreInputs",
          dynamicContent: "dynamicContent",
          defaultValues: "defaultValues",
          hideSidePanel: "hideSidePanel",
          recreateDemo: "recreateDemo",
          showResetButton: "showResetButton"
        },
        outputs: {
          recreateDemoChange: "recreateDemoChange",
          resetForm: "resetForm"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c3,
        decls: 1,
        vars: 1,
        consts: [["class", "ng-doc-playground-properties-wrapper", 3, "vertical", 4, "ngIf"], [1, "ng-doc-playground-properties-wrapper"], [1, "ng-doc-playground-demos"], ["class", "ng-doc-playground-properties", 4, "ngIf"], [1, "ng-doc-playground-properties"], [1, "ng-doc-playground-header"], ["ng-doc-text", ""], ["ng-doc-button", "", "color", "alert", 3, "click", 4, "ngIf"], [1, "ng-doc-playground-setting"], [3, "ngModelChange", "ngModel"], ["ng-doc-text", "", 3, "ngDocTooltip", "positions"], ["icon", "info", "ngDocTextRight", ""], [1, "ng-doc-playground-divider"], [4, "ngIf"], ["ng-doc-button", "", "color", "alert", 3, "click"], ["ng-doc-text", "", 1, "ng-doc-title"], [3, "name", "property", "typeControl", "defaultValue", "control", 4, "ngFor", "ngForOf"], [3, "name", "property", "typeControl", "defaultValue", "control"], [3, "name", "property", "typeControl", "control", 4, "ngFor", "ngForOf"], [3, "name", "property", "typeControl", "control"]],
        template: function NgDocPlaygroundPropertiesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocPlaygroundPropertiesComponent_div_0_Template, 5, 5, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.defaultValues);
          }
        },
        dependencies: [NgDocTextComponent, NgDocButtonComponent, NgDocCheckboxComponent, FormsModule, i2.NgControlStatus, i2.NgModel, NgDocTooltipDirective, NgDocIconComponent, NgDocTextRightDirective, NgIf, NgFor, NgDocPlaygroundPropertyComponent, AsyncPipe, KeyValuePipe, NgDocBindPipe, NgDocExecutePipe],
        styles: ["[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]{position:relative;display:flex;align-items:flex-start;gap:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper.vertical[_ngcontent-%COMP%]{flex-direction:column}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper.vertical[_ngcontent-%COMP%]   .ng-doc-playground-demos[_ngcontent-%COMP%]{margin-right:0;margin-bottom:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper.vertical[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-demos[_ngcontent-%COMP%]{position:sticky;display:flex;flex-direction:column;width:100%;min-width:0;z-index:4;top:calc(var(--ng-doc-page-sticky-offset) + var(--ng-doc-base-gutter))}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]{flex-shrink:0;align-self:normal;width:300px;padding:calc(var(--ng-doc-base-gutter) * 2) calc(var(--ng-doc-base-gutter) * 3);background-color:var(--ng-doc-base-1);border-radius:var(--ng-doc-base-gutter);border:1px solid var(--ng-doc-border-color)}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]   ng-doc-playground-property[_ngcontent-%COMP%]:not(:last-child){margin-bottom:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]   .ng-doc-playground-controls[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]   .ng-doc-playground-header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;height:40px;margin-bottom:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]   .ng-doc-playground-header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin:0}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-playground-properties[_ngcontent-%COMP%]   .ng-doc-playground-setting[_ngcontent-%COMP%]{display:flex;flex-direction:column}[_nghost-%COMP%]   .ng-doc-playground-properties-wrapper[_ngcontent-%COMP%]   .ng-doc-title[_ngcontent-%COMP%]{margin-top:0;margin-bottom:calc(var(--ng-doc-base-gutter) + var(--ng-doc-base-gutter) / 2)}[_nghost-%COMP%]   .ng-doc-playground-divider[_ngcontent-%COMP%]{margin:calc(var(--ng-doc-base-gutter) * 2) 0;height:1px;background-color:var(--ng-doc-base-2)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocPlaygroundPropertiesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocPlaygroundComponent = /*#__PURE__*/(() => {
  class NgDocPlaygroundComponent {
    constructor(rootPage, formBuilder) {
      this.rootPage = rootPage;
      this.formBuilder = formBuilder;
      this.id = '';
      this.pipeName = '';
      this.selectors = [];
      this.options = {};
      this.recreateDemo = false;
      this.defaultProperties = {};
      this.defaultContent = {};
    }
    ngOnChanges({
      options
    }) {
      if (options) {
        // Join configuration with options
        this.configuration = Object.assign({}, this.rootPage.page?.playgrounds?.[this.id], this.options);
      }
    }
    ngAfterViewInit() {
      this.defaultProperties = this.getPropertiesFormValues();
      this.defaultContent = this.getContentFormValues();
      const propertiesForm = this.formBuilder.group(this.defaultProperties);
      const contentForm = this.formBuilder.group(this.defaultContent);
      this.formGroup = this.formBuilder.group({
        properties: propertiesForm,
        content: contentForm
      });
      // `patchValue` is needed to set `undefined` values, otherwise they will be ignored by the Angular form
      this.formGroup.patchValue({
        properties: Object.assign({}, this.defaultProperties, this.configuration.inputs),
        content: this.defaultContent
      });
    }
    isDefaultState() {
      if (!this.formGroup) {
        return false;
      }
      return isSameObject(this.formGroup.value.properties ?? {}, this.defaultValues ?? {}) && isSameObject(this.formGroup.value.content ?? {}, this.defaultContent ?? {});
    }
    getPropertiesFormValues() {
      const formValues = objectKeys(this.properties ?? {}).reduce((controls, key) => {
        if (this.properties) {
          controls[key] = this.defaultValues ? this.defaultValues[key] : undefined;
        }
        return controls;
      }, {});
      return Object.assign({}, formValues, this.configuration.defaults);
    }
    getContentFormValues() {
      return objectKeys(this.configuration?.content ?? {}).reduce((controls, key) => {
        if (this.configuration?.content) {
          controls[key] = false;
        }
        return controls;
      }, {});
    }
    resetForm() {
      this.formGroup.reset({}, {
        emitEvent: false
      });
      this.formGroup?.patchValue({
        properties: this.defaultProperties,
        content: this.defaultContent
      });
    }
    static {
      this.ɵfac = function NgDocPlaygroundComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPlaygroundComponent)(i0.ɵɵdirectiveInject(i1$1.NgDocRootPage), i0.ɵɵdirectiveInject(i2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPlaygroundComponent,
        selectors: [["ng-doc-playground"]],
        inputs: {
          id: "id",
          pipeName: "pipeName",
          selectors: "selectors",
          properties: "properties",
          options: "options"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [3, "recreateDemoChange", "resetForm", "form", "properties", "ignoreInputs", "dynamicContent", "hideSidePanel", "defaultValues", "showResetButton", "recreateDemo"], [3, "id", "selector", "properties", "configuration", "recreateDemo", "form", "expanded", 4, "ngFor", "ngForOf"], [3, "id", "pipeName", "properties", "configuration", "recreateDemo", "form", 4, "ngIf"], [3, "id", "selector", "properties", "configuration", "recreateDemo", "form", "expanded"], [3, "id", "pipeName", "properties", "configuration", "recreateDemo", "form"]],
        template: function NgDocPlaygroundComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NgDocPlaygroundComponent_ng_container_0_Template, 5, 12, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.configuration);
          }
        },
        dependencies: [NgIf, NgDocPlaygroundPropertiesComponent, NgFor, NgDocPlaygroundDemoComponent, NgDocAsArrayPipe],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--ng-doc-playground-margin)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocPlaygroundComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Base class for playgrounds components.
 */
let NgDocBasePlayground = /*#__PURE__*/(() => {
  class NgDocBasePlayground {
    static {
      this.selector = 'unknown';
    }
    constructor(playgroundInstance) {
      this.playgroundInstance = playgroundInstance;
      this.properties = {};
      this.actionData = {};
      this.content = {};
      this.defaultValues = {};
      this.reattached = new Subject();
      this.playgroundContainer = inject(NgDocPlaygroundComponent);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.changeDetectorRef.detach();
    }
    get onReattached() {
      return this.reattached.pipe(take(1));
    }
    ngOnInit() {
      /*
       * Extract default values from playground properties. We do this in `ngOnInit` because in this case
       * input values provided from the template are not initialized yet, and we can read default values instead.
       */
      if (this.playground) {
        this.defaultValues = Object.keys(this.playground).reduce((values, key) => {
          if (this.playground) {
            try {
              values[key] =
              // @ts-expect-error we do not know the type of the playground
              typeof this.playground[key] === 'function' ?
              // @ts-expect-error we do not know the type of the playground
              this.playground[key]() :
              // @ts-expect-error we do not know the type of the playground
              this.playground[key];
            } catch (e) {
              // we do catch here because some of the playground properties can be getters and throw an error
            }
          }
          return values;
        }, {});
      } else if (this.playgroundInstance) {
        const defaults = extractFunctionDefaults(this.playgroundInstance.prototype.transform);
        this.defaultValues = Object.keys(this.playgroundContainer.properties ?? {}).reduce((def, key, i) => {
          // we do +1 because the first argument is the `value` of the transform function
          def[key] = defaults[i + 1];
          return def;
        }, {});
      } else {
        throw new Error('Playground is not defined or initialized');
      }
      if (!this.playgroundContainer.defaultValues) {
        this.playgroundContainer.defaultValues = this.defaultValues;
      }
      /*
               This is a hack just to wait for the playground container to be initialized and only then
               attach the change detector to have correct inputs values.
           */
      Promise.resolve().then(() => {
        this.changeDetectorRef.reattach();
        this.reattached.next();
      });
    }
    get data() {
      return Object.assign({}, this.configData, this.actionData);
    }
    static {
      this.ɵfac = function NgDocBasePlayground_Factory(__ngFactoryType__) {
        i0.ɵɵinvalidFactory();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocBasePlayground,
        inputs: {
          properties: "properties",
          actionData: "actionData",
          content: "content"
        }
      });
    }
  }
  return NgDocBasePlayground;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocBasePlayground, NgDocPlaygroundComponent, NgDocPlaygroundDemoComponent, NgDocPlaygroundPropertiesComponent, NgDocPlaygroundPropertyComponent };
